import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { ProviderEnum } from '@/types/common';
import { AdyenCard3DSForm } from './AdyenCard3DSForm';
import { StripeCard3DSForm } from './StripeCard3DSForm';

export const Card3DSForm = () => {
  const {
    threeDSSecurityState: { provider, show3DSForm },
  } = useContext(CheckoutContext);
  if (!show3DSForm || !provider) return null;

  if (provider === ProviderEnum.ADYEN) {
    return <AdyenCard3DSForm />;
  }

  if (provider === ProviderEnum.STRIPE) {
    return <StripeCard3DSForm />;
  }

  return null;
};
